<po-page-list #poPageListComponent
  p-title="Pedido de Venda - Lista"
  [p-breadcrumb]="breadcrumb"
  [p-filter]="filterSettings"
>
  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-height]="600"
    [p-hide-select-all]="true"
    [p-sort]="true"
    [p-striped]="true"
    [p-columns]="colunas"
    [p-items]="pedidosBloqueados"
    p-spacing="small"
  ></po-table>

</po-page-list>

<po-modal #advancedFilterModal p-title="Filtros" [p-primary-action]="advancedFilterPrimaryAction">
  <form #f="ngForm">
    <po-lookup class="po-md-4"
        name="CC5CLIENTELOJA"
        [(ngModel)]="pedidosBloqueadosFiltro.dados.CC5CLIENTELOJA"
        p-field-label="CA1NREDUZ"
        p-field-value="CA1CODLOJA"
        p-label="Cliente"
        [p-columns]="columnsClienteFilters"
        [p-field-format]="fieldFormaterClienteFilters"
        [p-filter-service]="clienteLookupService"
        [p-advanced-filters]="advancedClienteFilters"
        [p-literals]="{ modalTitle: 'Cliente' }"
        (p-selected)="clienteSelecionado($event)"
      ></po-lookup>
    <po-datepicker
      class="po-md-6"
      name="DC5EMISSAO_DE"
      [(ngModel)]="pedidosBloqueadosFiltro.dados.DC5EMISSAO_DE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data de"
    ></po-datepicker>
    <po-datepicker
      class="po-md-6"
      name="DC5EMISSAO_ATE"
      [(ngModel)]="pedidosBloqueadosFiltro.dados.DC5EMISSAO_ATE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data até"
    ></po-datepicker>
    <po-input
      class="po-md-6"
      name="CC5NUM"
      [(ngModel)]="pedidosBloqueadosFiltro.dados.CC5NUM"
      p-label="Código Pedido"
      [p-maxlength]="6"
    ></po-input>
  </form>
</po-modal>
